import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateConfigService } from 'app/common/translate/translate-config.service';

@Injectable({ providedIn: 'root' })
export class TitleService extends TitleStrategy {
  constructor() {
    super();
  }
  translateService = inject(TranslateConfigService);
  title = inject(Title);

  BASE_TITLE = 'P.Timer - ProjCont Timer';

  setTimerTitle(timerValue: string) {
    this.title.setTitle(timerValue + ' | ' + this.BASE_TITLE);
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const titleTranslateKey = this.buildTitle(snapshot);
    const title = titleTranslateKey && this.translateService.getTranslation(titleTranslateKey);
    if (title) {
      this.title.setTitle(title + ' | ' + this.BASE_TITLE);
    } else {
      this.title.setTitle(this.BASE_TITLE);
    }
  }
}
